export { default } from "./webp";
